import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { withUiBlock } from '@bingads-webui/uiblocker';
import template from './inline-edit-view-template.pug';
import { processError } from '../error-mapping';
import { EditPanelView, instrumentation } from '../hotel-center-shared';

const legacyI18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

/**
 * Class representing inline edit view
 * @extends View
 */
export default class InlineEditView extends DeterministicView {
  initialize({ view, hasCleanButton, i18n }) {
    this.i18n = i18n || legacyI18n;
    this.view = view;

    if (this.view instanceof DeterministicView) {
      this.setChild('child-view-container', this.view);
    }

    this.editPanelView = new EditPanelView();
    this.editPanelView.on('saved', () => {
      this.onSave();
    }, this);
    this.editPanelView.on('canceled', () => {
      this.onCancel();
    }, this);
    if (hasCleanButton) {
      this.editPanelView.setState({ hasCleanButton });
      this.editPanelView.on('cleaned', () => {
        this.getChild('child-view-container').clean();
      }, this);
    }
    this.setChild('edit-panel-view', this.editPanelView);

    this.setState({ errors: [] });
    this.overViewPageScenario = instrumentation.overViewPage.create();
  }

  get template() {
    return template;
  }

  onCancel() {
    this.setState({ errors: [] });
    this.trigger('close');
  }

  render() {
    super.renderTrunk();
  }

  onSave() {
    const state = this.view.getState();

    // not valid
    if (!state.isValid) {
      return;
    }

    this.processInlineEditChange(state, this);
    this.setState({ errors: [] });
  }

  processInlineEditChange(state, object) {
    const proto = Object.getPrototypeOf(object);
    const { i18n } = this;

    if (!proto) {
      return;
    }
    const properties = Object.getOwnPropertyNames(proto);
    const processEditFunction = _.filter(properties, func => func === 'processEditChange' && _.isFunction(this[func]));
    const { scope } = this;

    this[processEditFunction](state).then(() => {
      this.trigger('close', { refreshForGrid: true, refreshForSubAccountBar: this.refreshForSubAccountBar });
    }).catch((e) => {
      if (e.errors) {
        const errorInfo = processError({ errors: e.errors, scope, i18n });

        this.setState({ errors: [errorInfo] });
      }
    }).finally(withUiBlock(this.el));
  }
}
